<template>
    <div>

        <template v-if="checked">
            <sau-cancellation-pending :service="service"></sau-cancellation-pending>
            <sau-suspended-service v-if="suspended"></sau-suspended-service>
            <component :is="activeComponent" :service="service" v-else></component>
        </template>

        <template v-else>
            <sau-loading>
                <template slot="message">Fetching Service Summary</template>
            </sau-loading>
        </template>

    </div>
</template>

<script>
import VdsSummary from './vds/_Summary';
import VpsSummary from './vps/_Summary';
import ColoSummary from './colo/_Summary';
import DediSummary from './dedi/_Summary';
import CloudSummary from './cloud/_Summary';
import OtherSummary from './other/_Summary';
import VpsOaSummary from './vps-oa/_Summary';
import VpsXsSummary from './vps-xs/_Summary';
import LegacySummary from './legacy/_Summary';
import HadraasSummary from './hadraas/_Summary';
import TransitSummary from './transit/_Summary';
import FirewallSummary from './firewall/_Summary';
import WordpressSummary from './wordpress/_Summary';
import CrossConnectSummary from './cross-connect/_Summary';
import SslCertificateSummary from './ssl-certificate/_Summary';

export default {
    props: ['service'],

    components: {
        'sau-vds-summary': VdsSummary,
        'sau-vps-summary': VpsSummary,
        'sau-dedi-summary': DediSummary,
        'sau-colo-summary': ColoSummary,
        'sau-cloud-summary': CloudSummary,
        'sau-other-summary': OtherSummary,
        'sau-vps-oa-summary': VpsOaSummary,
        'sau-vps-xs-summary': VpsXsSummary,
        'sau-legacy-summary': LegacySummary,
        'sau-hadraas-summary': HadraasSummary,
        'sau-transit-summary': TransitSummary,
        'sau-firewall-summary': FirewallSummary,
        'sau-wordpress-summary': WordpressSummary,
        'sau-cross-connect-summary': CrossConnectSummary,
        'sau-ssl-certificate-summary': SslCertificateSummary,
    },

    data() {
        return {
            checked: false,
            suspended: false,
            activeComponent: '',
        }
    },

    created() {
        // Lock down functionality if the service is suspended
        if (this.service.status.toLowerCase() == 'suspended') {
            this.suspended = true;
        } else {
            this.loadServiceSummary();
            this.$store.commit('setCurrentService', this.service);
        }

        this.checked = true;
    },
    methods: {
        loadServiceSummary() {
            switch(this.service.type.toLowerCase()) {
                case 'colocation' :
                    this.activeComponent = 'sau-colo-summary';
                        break;
                case 'cloud' :
                    this.activeComponent = 'sau-cloud-summary';
                        break;
                case 'vds' :
                    this.activeComponent = 'sau-vds-summary';
                        break;
                case 'vps' :
                    this.activeComponent = 'sau-vps-summary';
                        break;
                case 'dedicated-server' :
                    this.activeComponent = 'sau-dedi-summary';
                        break;
                case 'transit' :
                    this.activeComponent = 'sau-transit-summary';
                        break;
                case 'managed-wordpress' :
                    this.activeComponent = 'sau-wordpress-summary';
                        break;
                case 'firewall' :
                    this.activeComponent = 'sau-firewall-summary';
                        break;
                case 'hadraas' :
                    this.activeComponent = 'sau-hadraas-summary';
                        break;
                case 'vps-oa' :
                    this.activeComponent = 'sau-vps-oa-summary';
                        break;
                case 'vps-xs' :
                    this.activeComponent = 'sau-vps-xs-summary';
                        break;
                case 'ssl-certificate' :
                    this.activeComponent = 'sau-ssl-certificate-summary';
                        break;
                case 'cross-connect' :
                    this.activeComponent = 'sau-cross-connect-summary';
                        break;
                case 'legacy' :
                    this.activeComponent = 'sau-legacy-summary';
                        break;
                case 'other' :
                default :
                    this.activeComponent = 'sau-other-summary';
                        break;
            }
        }
    },
}
</script>
